import Map from "./Map";

const Single = {
  init: () => {
    // check single post page
    const isSinglePost = document.querySelector("body.single");
    if (!isSinglePost) return;

    // create map!
    Map.init();
  },
};

export default Single;
